import { FaCopy, FaEye, FaPlay, FaPlus, FaShare, FaCopyright, FaCalendarDay } from "react-icons/fa";
import { MdGrade, MdTopic } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from 'react'
import CustomModal from "./CustomModal";
import LessonForm from "./LessonForm";
import { LessonDetails } from '../pages'
import { MdEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import { encryptHref } from "../utils";
import toast, { Toaster } from 'react-hot-toast';
import CopyCourseMaterial from "./CopyCourseMaterial";
import axios from "axios";
import { BASE_URL } from "../constants";
import { CgSmartphoneChip } from "react-icons/cg";
import LoadingRobot from "../assets/robot.gif"
import PublishModal from "./PublishModal";
import Swal from "sweetalert2";

const PreviewCard = ({ card, constants }) => {
  const user = useSelector(state => state.user.details);
  const { type } = useParams();
  const [modal, setModal] = useState({ open: false })
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const copyLesson = async (formData, setError) => {
    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/lesson/copyLesson.php?lessonId=${card.id}`,
        formData
      );
      setLoading(false);
      const resObject = await res.data;

      if (res.status == 201) {
        closeModal();
        navigate(`/lessons/${await encryptHref(resObject.data.id)}`);
      }

    } catch (error) {
      setLoading(false);

      if (error.response.data.data.error) {
        setError(error.response.data.data.error);
      } else {
        console.log(error);
      }
    }
  }

  const createLesson = async (formData, setError) => {
    setLoading(true);

    try {
      const endpoint = modal.ai == true ? 'createLessonWithAI.php' : 'createLesson.php';
      const res = await axios.post(`${BASE_URL}/lesson/${endpoint}`,
        formData,
      );
      setLoading(false);
      const resObject = await res.data;

      if (res.status == 201) {
        closeModal();
        navigate(`/lessons/${await encryptHref(resObject.data.id)}`);
      }

    } catch (error) {
      setLoading(false);

      if (error.response.data.data.error) {
        Swal.fire({
          title: 'Error creating Lesson',
          text: error.response.data.data.error.title,
          icon: 'error'
        })
        setError(error.response.data.data.error);
      } else {
        console.log(error);
      }
    }
  }

  const handleCopy = () => {
    setModal({ open: true, mode: 'copy' })
  }

  const handleCreate = (ai = false) => {
    setModal({ open: true, mode: 'create', ai })
  }

  const handlePreview = (targetId) => {
    setModal({ open: true, mode: 'preview', targetId })
  }

  const closeModal = () => {
    setModal({ open: false })
  }

  const handlePublish = (targetId) => {
    setModal({ open: true, mode: 'publish', targetId })
  }

  return (
    <section className='preview-card relative'>
      {(user.userId == card.user_id || user.roleId == 1) && <button className="absolute right-1 top-1 p-2 z-10 edit" onClick={async () => navigate(`${type == 'lesson' ? `/lessons/${await encryptHref(card.id)}` : `/update-video/${await encryptHref(card.id)}`}`)}><MdEdit fontSize={20} /></button>}
      {/* thumbnail */}
      <div className="relative hover:scale-105 duration-500 w-full h-full min-h-48">
        <img src={card.thumbnail} alt="logo" className="rounded-t-lg w-full h-full object-cover" />

        <button onClick={async () => handlePreview(await encryptHref(card.id))} className="absolute inset-0 flex justify-center items-center bg-gray-600 bg-opacity-0 hover:bg-opacity-40">
          <FaPlay className="text-gray-100 opacity-70" fontSize={40} />
        </button>
      </div>

      {/* title desc grade subject */}
      <div className="flex flex-col justify-between h-full gap-4 px-4 w-full">
        <div className="flex flex-col gap-2">
          <h1 className="capitalize m-0 text-2xl line-clamp-2">{card.title}</h1>
          <p className="m-0 line-clamp-3">{card.description}</p>

          <div className="flex gap-2 mt-2">
            <div className="flex items-center gap-1 w-full text-green-500">
              <MdGrade fontSize={20} />
              <span className="font-semibold">{constants.Grades?.filter(grade => grade.id == card.grade_id)[0]?.grade}</span>
            </div>

            <div className="flex items-center gap-1 w-full text-yellow-500">
              <MdTopic fontSize={20} />
              <span className="font-semibold">{constants.Subjects?.filter(subject => subject.id == card.subject_id)[0]?.title}</span>
            </div>
          </div>
        </div>

        {/* created by and timestamps */}
        <div className="flex flex-col gap-1 text-sm text-gray-500">
          <span className="flex items-center gap-1 capitalize">
            <FaCopyright />
            {card.creator}
          </span>
          <span className="flex items-center gap-1">
            <FaCalendarDay />
            {new Date(card.timestamp).toDateString()}
          </span>
        </div>

        <div className="text-sm flex flex-col gap-2">
          <div className="flex gap-2">
            {
              type == 'video' &&
              <button className="outline-button w-full" onClick={handleCreate}>
                <FaPlus />
                Create Lesson
              </button>
            }

            {
              type == 'lesson' &&
              <button className="outline-button w-full" onClick={handleCopy}>
                <FaCopy />
                Copy
              </button>
            }

            {
              type == 'lesson' &&
              <button className="outline-button w-full" onClick={async () => navigate(`/lessons/${await encryptHref(card.id)}`)}>
                <FaEye />
                Preview
              </button>
            }
          </div>

          {
            type == 'video' &&
            <button className="outline-button w-full truncate" onClick={() => handleCreate(true)}>
              <CgSmartphoneChip fontSize={20} />
              Create Lesson Using AI
            </button>
          }

          {
            type == 'lesson' && (user.userId == card.user_id || user.roleId == 1) &&
            <button className="outline-button w-full" onClick={async () => handlePublish(await encryptHref(card.id))}>
              <FaShare />
              Publish
            </button>
          }
        </div>
      </div>

      {/* video modal */}
      <CustomModal open={modal.open} handleClose={closeModal}>
        {
          modal.mode == 'preview' &&
          <>
            {type == "video" && (card?.murl.includes("youtube") || card?.lurl.includes("youtube")) ? (
              <iframe className="w-full min-h-[480px]" src={`https://www.youtube.com/embed/${card.murl.split("watch?v=")[1]}`} />
            ) : type == 'video' && <video className="w-full" controls src={card.murl || card.lurl} autoPlay />}

            {type == 'lesson' && <LessonDetails passedId={modal.targetId} initialConstants={constants} />}
          </>
        }
        {
          (modal.mode == 'create') ?
            (loading && modal.ai) ?
              <img src={LoadingRobot} alt="loading" className="rounded-full" />
              :
              <LessonForm handleFormAction={createLesson} video={card} loading={loading} />
            :
            null
        }

        {modal.mode == 'copy' && <LessonForm copy={true} handleFormAction={copyLesson} lesson={card} loading={loading} />}

        {
          modal.mode == 'publish' && (
            <PublishModal
              // value={`${window.location.origin}/lessonsview/${modal.targetId}`}
              callback_onclick={() => { navigator.clipboard.writeText(document.getElementById('publish_link').value); toast.success("Link copied to clipboard!") }}
              title={card.title}
              closeModal={() => { closeModal() }}
              targetId={modal.targetId}
            />
          )
        }
      </CustomModal>
    </section>
  )
}

export default PreviewCard